<template>
  <div>
    <div class="input-group date input-group-date">
      <div class="input-group-prepend">
        <span class="input-group-addon" @click.stop="$refs.datePickerInput.click()"><i class="far fa-calendar"></i></span>
      </div>
      <v-date-picker
      ref="datePicker"
      mode='single'
      v-model='selectedValue'
      :min-date="_minimumDate"
      :max-date="_maximumDate"
      :popover="configPopover"
      :input-debounce="250"
      :update-on-input="false"
      locale="en-AU">
        <input
            ref="datePickerInput"
            slot-scope="{ inputProps, inputEvents }"
            :placeholder="placeholder"
            :class="[`form-control form-control-date`, { 'is-invalid': hasError() }]"
            v-bind="inputProps"
            v-on="inputEvents"
            v-on:keyup.enter="$refs.datePicker.hidePopover()" />
      </v-date-picker>
    </div>
    <div class="form-invalid-feedback" v-if="hasError()" style="clear: both;">
      {{getError()}}
    </div>
    <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
  </div>
</template>

<style>
input.form-control.form-control-date {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.form-control-date[readonly] {
  background-color: #ffffff;
}
.input-group-date {
  flex-wrap: nowrap;
}
.input-group-date .input-group-addon {
  border-right: none;
}
</style>

<script>
import formField from '@/mixins/formField'
import moment from 'moment'

export default {
  name: "FormDate",
  mixins: [formField],
  props: {
    value: {
      type: String,
      default: ''
    },
    minDate: String,
    maxDate: String,
    placeholder: String,
    field: String,
    note: String
  },
  computed: {
    _minimumDate() {
      if(this.$props.minDate)
        return moment(this.$props.minDate).toDate()
      return null
    },
    _maximumDate() {
      if(this.$props.maxDate)
        return moment(this.$props.maxDate).toDate()
      return null
    }    
  },
  data() {
    var curValue = null
    if(this.$props.value)
      curValue = moment(this.$props.value).toDate()

    return {
      selectedValue: curValue,
      configPopover: {
        keepVisibleOnInput: false,
        positionFixed: true,
        visibility: 'click',
        transition: 'none'
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      } else {
        this.$data.selectedValue = moment(newVal).toDate()
      }
    },
    selectedValue: function(newVal, oldVal) {
      try {
        if(newVal != null)
          this.$emit('input', newVal.toISOString())
      } catch {}
    }
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    updateValue(evt) {
      this.$emit('input', evt.toISOString())
    }
  }
};
</script>